import Client from '@/hexapla-core/client'
import { WitnessType } from '@/hexapla-core/domains/resources'
import { Domain } from '@/hexapla-core/domains'

export interface WitnessTypeService extends Domain<WitnessType> {
  index: (url: string) => Promise<WitnessType[]>
  show: (url: string, id: string | number) => Promise<WitnessType>
  create: (url: string, type: WitnessType) => Promise<WitnessType>
  update: (url: string, type: WitnessType) => Promise<WitnessType>
  destroy: (url: string, id: string | number) => Promise<void>
}

export const index = (url: string): Promise<WitnessType[]> =>
  Client.get<WitnessType[]>(`${url}/api/witnesses/types`)

export const show = (url: string, typeID: string | number): Promise<WitnessType> =>
  Client.get<WitnessType>(`${url}/api/witnesses/types/${typeID}`)

export const create = (url: string, type: WitnessType): Promise<WitnessType> =>
  Client.post<WitnessType, WitnessType>(`${url}/api/witnesses/types`, type)

export const update = (url: string, type: WitnessType): Promise<WitnessType> =>
  Client.patch<WitnessType, WitnessType>(`${url}/api/witnesses/types/${type.id}`, type)

export const destroy = (url: string, typeID: string | number): Promise<void> =>
  Client.destroy<void>(`${url}/api/admin/witnesses/types/${typeID}`)

export default {
  index,
  show,
  create,
  update,
} as WitnessTypeService
